__turbopack_context__.v({
  "icon": "HeroForm-module__7ENZQa__icon",
  "iconContainer": "HeroForm-module__7ENZQa__iconContainer",
});
